export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgIi9hc3NldHMvbG9nby5kMGM5ZmJlMy43ZWMxZGIzMS1iY2FiLTQ5NWItOTY5OS02ZWYwZTgyYjc0MDYucG5nIjs="